import { useEffect, useState } from "react";
import axiosUserInstance from "../../axiosUserInstance";
import { formatDDMMYY } from "../../utils/common";

const FormTab = ({ widgetId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [responses, setResponses] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [total, setTotal] = useState(0);

  const fetchResponses = async (p = 1) => {
    try {
      setLoading(true);
      setError(null);

      const params = { page: p, limit };
      if (widgetId) params.widgetId = widgetId;

      const resp = await axiosUserInstance.get("/user/form/responses", {
        params,
      });

      if (resp?.status === 200) {
        setResponses(resp?.data?.data || []);
        setTotal(resp?.data?.pagination?.total || 0);
      } else {
        setError(resp?.data?.message || "Failed to load responses");
      }
    } catch (err) {
      console.error("Error fetching form responses:", err);
      setError(err?.response?.data?.message || err.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResponses(page);
  }, [page]);

  const totalPages = Math.max(1, Math.ceil(total / limit));

  return (
    <div className="form-tab">
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div style={{ color: "#dc3545" }}>Error: {error}</div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table className="table table-hover table-sm">
            <thead className="table-light">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Number</th>
                <th>DOB</th>
                <th>Country</th>
              </tr>
            </thead>
            <tbody className="table-group-divider">
              {responses?.length === 0 ? (
                <tr>
                  <td colSpan={7}>No responses found</td>
                </tr>
              ) : (
                responses?.map((r) => (
                  <tr key={r?._id}>
                    <td>{r?.formData?.name || "-"}</td>
                    <td>{r?.formData?.email || "-"}</td>
                    <td>{r?.formData?.number || "-"}</td>
                    <td>
                      {r?.formData?.dob ? formatDDMMYY(r.formData.dob) : "-"}
                    </td>
                    <td>{r?.formData?.country || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className="d-flex items-center justify-content-between">
            <div>
              Showing {responses?.length} of {total} responses
            </div>
            <div>
              <button
                className="btn btn-sm btn-light"
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page <= 1}
              >
                Prev
              </button>
              <span style={{ margin: "0 8px" }}>
                {page} / {totalPages}
              </span>
              <button
                className="btn btn-sm btn-light"
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page >= totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormTab;
